package com.upcominds.expedite

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.runtime.rememberCoroutineScope
import com.upcominds.expedite.di.initKoin
import com.upcominds.expedite.di.getKoin
import com.upcominds.expedite.di.platformModule
import com.upcominds.expedite.web.WebDashboardScreen
import com.upcominds.expedite.web.WebSplashScreen
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.renderComposable
import kotlinx.browser.window
import com.upcominds.expedite.data.NetworkClient

/**
 * Minimal DOM-based web entry.
 *
 * This renders into the element with id="root" from `index.html`.
 */
fun main() {
    initKoin(platformModule())

    // Update base URL to use the current origin (e.g. localhost:8081)
    // This allows the Webpack proxy to handle the request forwarding and avoid CORS
    NetworkClient.baseUrl = window.location.origin

    renderComposable(rootElementId = "root") {
        WebApp()
    }
}

private enum class WebRoute { Splash, Home }

@Composable
fun WebApp() {
    var route by remember { mutableStateOf(WebRoute.Splash) }

    val scope = rememberCoroutineScope()
    // Resolving AuthRepository here to access login/logout
    val authRepository = remember { getKoin().get<com.upcominds.expedite.data.auth.AuthRepository>() }

    when (route) {
        WebRoute.Splash -> WebSplashScreen(
            toHome = { route = WebRoute.Home },
            toLogin = {
                scope.launch {
                    try {
                        authRepository.login()
                        NetworkClient.clearAuthTokenCache()
                    } catch (e: Exception) {
                        console.error("Login failed", e)
                    }
                }
            }
        )

        WebRoute.Home -> WebDashboardScreen(
            onLogout = {
                scope.launch {
                    authRepository.logout()
                    NetworkClient.clearAuthTokenCache()
                    route = WebRoute.Splash
                }
            }
        )
    }
}
